module.exports = __webpack_public_path__ + "img/company_confetti.7da4bb2.svg";